const { default: axios } = require("axios");

const axiosClient = axios.create({
  baseURL: "https://api-mail.starnestsolution.com/api",
  timeout: 50000,
});

export default axiosClient;
